import { render } from "./SectionP.vue?vue&type=template&id=797789e0&scoped=true"
import script from "./SectionP.vue?vue&type=script&lang=js"
export * from "./SectionP.vue?vue&type=script&lang=js"

import "./SectionP.vue?vue&type=style&index=0&id=797789e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797789e0"]])

export default __exports__